import { Http } from "@/util";

export function submitEvSimulate(param) {
  return Http.post("/admin/ev/submit_simulate", param);
}

export function getEvSimulateTask(taskId) {
  return Http.get("/admin/ev/simulate_task", { taskId, _hideLoading: true });
}

export function getEvPlanView(param) {
  return Http.get("/admin/ev/plan_view", param);
}

export function getEvSellableView(param) {
  return Http.get("/admin/ev/sellable_view", param);
}

export function getEvOpAreaHourView(param) {
  return Http.get("/admin/ev/op_area_hour_view", param);
}

export function getEvSolveSummaryView(param) {
  return Http.get("/admin/ev/solve_summary_view", param);
}

export function getEvVehicleTipView(param) {
  return Http.get("/admin/ev/vehicle_tip_view", param);
}

export function getEvStartVehicleTipView(param) {
  return Http.get("/admin/ev/start_vehicle_tip_view", param);
}

export function getEvTunableConfig(param) {
  return Http.get("/admin/ev/tunable_config", param);
}

export function applyEvTunableConfig(data) {
  const payload = { ...(data || {}) };
  return Http.post("/admin/ev/tunable_config/apply", { ...payload, _hideLoading: true });
}

export function getEvTemplateVehicles(param) {
  return Http.get("/admin/ev/template_vehicles", param);
}

export function listEvTemplateVehicleDates(param) {
  return Http.get("/admin/ev/template_vehicles/dates", param);
}

export function saveEvTemplateVehicles(data) {
  return Http.post("/admin/ev/template_vehicles/save", { ...(data || {}), _hideLoading: true });
}

export function deleteEvTemplateVehicles(data) {
  return Http.post("/admin/ev/template_vehicles/delete", { ...(data || {}), _hideLoading: true });
}

export function getEvUsableDrivers(param) {
  return Http.get("/admin/ev/usable_drivers", param);
}
